import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import BrandNav from "../components/BrandNav";
import { api } from "../lib/api";
import { extractError } from "../lib/format";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [token, setToken] = useState(params.get("token") || "");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password updated. Sign in with your new password.");
      nav("/login", { replace: true });
    } catch (e) {
      setErr(extractError(e, "Reset failed."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="reset-page">
      <BrandNav />
      <main className="ftg-shell ftg-page">
        <div className="ftg-auth">
          <h1>Choose a new password</h1>
          <p className="ftg-auth__sub">Paste the reset token from your email (Phase C1: from the server log).</p>
          <form className="ftg-form" onSubmit={submit} data-testid="reset-form">
            <div className="ftg-field">
              <label className="ftg-field__label" htmlFor="r-token">Reset token</label>
              <input id="r-token" className="ftg-field__input" required value={token} onChange={(e) => setToken(e.target.value)} data-testid="reset-token-input" />
            </div>
            <div className="ftg-field">
              <label className="ftg-field__label" htmlFor="r-pw">New password (8+ chars)</label>
              <input id="r-pw" className="ftg-field__input" type="password" minLength={8} required value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password-input" />
            </div>
            {err ? <div className="ftg-form__error" data-testid="reset-error">{err}</div> : null}
            <button className="ftg-btn ftg-btn--primary ftg-btn--large ftg-btn--block" disabled={busy} data-testid="reset-submit-btn">
              {busy ? "Saving…" : "Set new password"}
            </button>
          </form>
          <div className="ftg-auth__foot">
            <Link to="/login" data-testid="reset-back-login">Back to sign-in</Link>
          </div>
        </div>
      </main>
    </div>
  );
}
